module.exports = __webpack_public_path__ + "img/VIETTELQR1.1c5ae66d.svg";